<template>
    <span>
        <span v-if="prefix?.length > 0"> {{ prefix }}</span>
        {{ value.toLocaleString(undefined, {minimumFractionDigits: (noPadding ? 0 : decimals), maximumFractionDigits: decimals}) }}
        <span v-if="currency?.length > 0"> {{ currencySymbol }}</span>
    </span>
</template>

<script>
export default {
    name: 'Price',

    props: {
        value: Number,
        noPadding: Boolean,
        prefix: String,
        decimals: {
            type: Number,
            default: 2
        },
        currency: {
            type: String,
            default: '€',
        },
    },

    computed: {
        currencySymbol () {
            switch (this.currency) {
                case 'EUR':
                default:
                    return '€'
                case 'USD':
                    return '$'
            }
        }
    }
}
</script>
